import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
	OAccessoiresBasicInfo,
	OFeaturedImageUpload,
	OImagePreview,
	OSmartInputSection,
	ODestructiveButtons,
} from '../components/organisme';

import { CMS_CONFIG } from '../config/cms.config';
import { setCmsHead } from '../redux/head/headActions';
import withAuthGuard from '../helpers/withAuthGuard';

class CreateAccessoiresPage extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isValid: false,
		};
	}

	componentDidMount() {
		const document = CMS_CONFIG.LINKS.find(item => item.title === 'Vertaling');
		this.props.setCmsHead({ ...document });
	}

	handleSave() {}
	handleDelete() {}

	render() {
		return (
			<div className="layout-cms--wrapper">
				<form noValidate>
					<div className="layout-cms--content-body--create">
						<OAccessoiresBasicInfo

						/>
						<OFeaturedImageUpload />
						<OImagePreview />
						<OSmartInputSection
							title="Documenten"
							optional
						/>
						<OSmartInputSection
							title="Tags"
							optional
						/>
					</div>
					<div className="section-cms--destructive-buttons">
						<ODestructiveButtons
							onSave={this.handleSave}
							onDelete={this.handleDelete}
							saveEnabled={this.state.isValid}
						/>
					</div>
				</form>
			</div>
		);
	}
}

CreateAccessoiresPage.propTypes = {
	setCmsHead: PropTypes.func.isRequired,
};

export default withAuthGuard(withRouter(connect(null, {
	setCmsHead,
})(CreateAccessoiresPage)));



// WEBPACK FOOTER //
// ./src/CMS/create-accessoires.js